import { FC } from 'react';
import styled from 'styled-components';
import { Input, InputProps } from '../Input/Input';

const StyledEditableText = styled(Input)<{
  darkMode?: boolean;
  charLength?: number;
  hasCharCount?: boolean;
}>`
  margin: 0 -0.5rem;
  input {
    padding: ${({ darkMode }) => (darkMode ? '14px 16px 14px 16px' : '1000 0.5rem')};
    background-color: transparent;
    transition: ${({ theme }) => theme.vars.transition.default};
    font-size: ${({ darkMode }) => (darkMode ? '14px' : '18px')};
    font-weight: ${({ darkMode }) => (darkMode ? '350' : '600')};
    color: ${({ darkMode }) => (darkMode ? '#FFFFFF' : '#1D2226')};
    border: 1px solid transparent;
    :focus-within {
      border-top: ${props =>
        props.hasCharCount
          ? props.charLength > 0 && props.charLength <= 4
            ? '1px solid #FFAF66'
            : props.charLength > 4
            ? '1px solid #71DA96'
            : '1px solid #d6deea'
          : props.darkMode && '1px solid #d6deea'};
      border-left: ${props =>
        props.hasCharCount
          ? props.charLength > 0 && props.charLength <= 4
            ? '1px solid #FFAF66'
            : props.charLength > 4
            ? '1px solid #71DA96'
            : '1px solid #d6deea'
          : props.darkMode && '1px solid #d6deea'};
    }

    :hover,
    :focus {
      background-color: ${({ theme, darkMode }) => (darkMode ? 'transparent' : theme.vars.newColor.lightGS2)};
    }
  }
  :focus-within {
    .input-state {
      border-bottom: ${props =>
        props.hasCharCount
          ? props.charLength > 0 && props.charLength <= 4
            ? '2px solid #FFAF66'
            : props.charLength > 4
            ? '2px solid #71DA96'
            : '2px solid #d6deea'
          : '2px solid #0067E5'};
    }
  }
  .input-state {
    transition: all 0.2s ease-in-out;
    position: absolute;
    width: 100%;
    bottom: 0;
  }
`;

export const EditableText: FC<InputProps> = props => (
  <StyledEditableText charLength={props.charLength} darkMode={props.darkMode} {...props} />
);
